<template>
    <div class="border-sm profile-circle" :style="circleStyle">
        <span>{{ initials }}</span>
    </div>
</template>

<script>
export default {
    name: "ProfileCircle",
    props: {
        name: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 30,
        },
    },
    computed: {
        initials() {
            if (!this.name) return "";
            const nameParts = this.name.trim().split(" ");
            let initials = ''
            if (nameParts.length != 2) {
                initials = this.name[0] + this.name[1]
            }
            else {
                initials = nameParts[0][0] + nameParts[1][0]
            }
            
            return initials;
        },
        circleStyle() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                fontSize: `${this.size / 2.5}px`,
            };
        },
    },
};
</script>

<style scoped>
.profile-circle {
    border-color: rgb(65, 65, 65);
    color: rgb(65, 65, 65);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-transform: uppercase;
    user-select: none;
    margin-right: 10px;
}
</style>